export default "__VITE_ASSET__065bd2db__"